/**
 * Cart Discount Preview — global entrypoint.
 *
 * Listens for cart settle events and syncs custom discount-engine preview
 * pricing into the cart drawer + cart page without mutating Shopify cart data.
 *
 * Endpoint / enable flag come from Theme settings via `Theme.cartDiscountPreview`
 * (see `snippets/cart-discount-preview-boot.liquid`).
 */
import { CartDiscountPreviewController } from '@theme/cart-discount-preview-controller';

const cfg = globalThis.Theme?.cartDiscountPreview;
const controller = CartDiscountPreviewController.getInstance();

if (cfg?.enabled !== false && typeof cfg?.endpoint === 'string' && cfg.endpoint.trim()) {
  controller.connect();
}

export { CartDiscountPreviewController };
export default controller;
